import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const MediaIcon: React.FC<AddIconProps> = ({ size = 22, color = '#0556CB', className, onClick }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.6997 28.0335L31.4831 15.8335C30.5331 13.6002 29.1164 12.3335 27.4997 12.2502C25.8997 12.1669 24.3497 13.2835 23.1664 15.4169L19.9997 21.1002C19.3331 22.3002 18.3831 23.0169 17.3497 23.1002C16.2997 23.2002 15.2497 22.6502 14.3997 21.5669L14.0331 21.1002C12.8497 19.6169 11.3831 18.9002 9.88307 19.0502C8.38307 19.2002 7.09974 20.2335 6.24974 21.9169L3.36641 27.6669C2.33307 29.7502 2.43307 32.1669 3.64974 34.1335C4.86641 36.1002 6.98307 37.2835 9.29974 37.2835H30.5664C32.7997 37.2835 34.8831 36.1669 36.1164 34.3002C37.3831 32.4335 37.5831 30.0835 36.6997 28.0335Z" fill={color} fillOpacity="0.3" />
    <path d="M11.6167 13.9669C14.7279 13.9669 17.2501 11.4447 17.2501 8.33353C17.2501 5.22232 14.7279 2.7002 11.6167 2.7002C8.50553 2.7002 5.9834 5.22232 5.9834 8.33353C5.9834 11.4447 8.50553 13.9669 11.6167 13.9669Z" fill={color} fillOpacity="0.2" />
  </svg>


);

export default MediaIcon;
